import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Work',
    href: '#work'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-cream/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-101">
        <a href="#" className="text-3xl md:text-4xl font-serif tracking-tight z-50 relative" data-id="element-102">
          Oli Creative<span className="text-accent" data-id="element-103">.</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-104">
          <ul className="flex gap-8" data-id="element-105">
            {navLinks.map(link => <li key={link.name} data-id="element-106">
                <a href={link.href} className="text-sm font-medium text-ink-light hover:text-accent transition-colors" data-id="element-107">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contact" className="px-5 py-2.5 bg-ink text-cream text-sm font-medium rounded-full hover:bg-accent transition-colors duration-300" data-id="element-108">
            Let's Talk
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 relative p-2 -mr-2 text-ink" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-109">
          {mobileMenuOpen ? <X size={24} data-id="element-110" /> : <Menu size={24} data-id="element-111" />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-112">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3,
          ease: 'custom-ease'
        }} className="fixed inset-0 bg-cream z-40 flex flex-col justify-center items-center px-6" data-id="element-113">
              <ul className="flex flex-col items-center gap-8 text-center" data-id="element-114">
                {navLinks.map(link => <li key={link.name} data-id="element-115">
                    <a href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-4xl font-serif text-ink hover:text-accent transition-colors" data-id="element-116">
                      {link.name}
                    </a>
                  </li>)}
                <li className="mt-4" data-id="element-117">
                  <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="px-8 py-4 bg-ink text-cream text-lg font-medium rounded-full hover:bg-accent transition-colors duration-300 inline-block" data-id="element-118">
                    Let's Talk
                  </a>
                </li>
              </ul>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}